import React from 'react';

// Bénin lagoon seasons: (dry season = ideal, small rains, big rains)
// From knowledge base: Nov-Feb dry ideal; Mar dry-hot; Apr-May small rains; Jun-Jul big rains (worst);
// Aug small dry ("petite saison sèche"); Sep-Oct small rains
const MONTHS = [
  { label: 'JAN', short: 'Jan', season: 'ideal',  icon: '😄☀️', desc: 'Saison sèche · lumière dorée' },
  { label: 'FÉV', short: 'Fév', season: 'ideal',  icon: '😄☀️', desc: 'Ciel dégagé · vent doux' },
  { label: 'MARS', short: 'Mar', season: 'ideal', icon: '🙂🌤', desc: 'Chaleur montante · idéal matin' },
  { label: 'AVR', short: 'Avr', season: 'ok',     icon: '🙂🌦', desc: 'Petite saison des pluies' },
  { label: 'MAI', short: 'Mai', season: 'rain',   icon: '😔🌧', desc: 'Averses fréquentes' },
  { label: 'JUIN', short: 'Juin', season: 'rain', icon: '😔⛈', desc: 'Grande saison des pluies' },
  { label: 'JUIL', short: 'Juil', season: 'rain', icon: '😢🌧', desc: 'Pluies soutenues' },
  { label: 'AOÛT', short: 'Août', season: 'ok',   icon: '🙂🌤', desc: 'Petite saison sèche' },
  { label: 'SEPT', short: 'Sept', season: 'ok',   icon: '🙂🌦', desc: 'Averses possibles' },
  { label: 'OCT', short: 'Oct', season: 'ok',     icon: '🙂🌤', desc: 'Fin des pluies · éclaircies' },
  { label: 'NOV', short: 'Nov', season: 'ideal',  icon: '😄☀️', desc: 'Retour du beau temps' },
  { label: 'DÉC', short: 'Déc', season: 'ideal',  icon: '😄☀️', desc: 'Harmattan · lumière pure' },
];

const SEASON_META = {
  ideal: { color: 'bg-emerald-500', label: 'Période idéale', ring: 'ring-emerald-200' },
  ok:    { color: 'bg-amber-500',   label: 'Correct, averses possibles', ring: 'ring-amber-200' },
  rain:  { color: 'bg-slate-400',   label: 'Saison des pluies', ring: 'ring-slate-200' },
};

const LagoonMonthly = () => {
  return (
    <section id="meteo-lagune" className="bg-[#FAF7F2] pt-16 pb-20 px-6" data-testid="lagoon-monthly">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight">
            La lagune <span className="text-[#E89534]">mois par mois</span>
          </h2>
          <p className="text-slate-600 mt-4 max-w-2xl mx-auto">
            Le lac se visite toute l'année. Ces repères concernent la météo, la hauteur d'eau et la lumière.
          </p>
        </div>

        <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-12 gap-3">
          {MONTHS.map((m) => {
            const meta = SEASON_META[m.season];
            return (
              <div
                key={m.label}
                data-testid={`month-${m.label.toLowerCase()}`}
                className={`group relative bg-white rounded-2xl px-2 py-4 text-center shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all cursor-help ring-1 ${meta.ring}`}
                title={m.desc}
              >
                <div className="text-[11px] font-bold text-slate-500 tracking-widest mb-2">{m.label}</div>
                <div className="text-2xl mb-2 leading-none">{m.icon}</div>
                <div className={`w-2 h-2 rounded-full mx-auto ${meta.color}`}></div>

                {/* Tooltip */}
                <div className="absolute inset-x-0 -bottom-2 translate-y-full opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-opacity z-20 px-2">
                  <div className="bg-slate-900 text-white text-[11px] font-medium px-3 py-2 rounded-xl shadow-xl leading-tight">
                    {m.desc}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 mt-8 text-xs text-slate-600">
          {Object.entries(SEASON_META).map(([k, meta]) => (
            <div key={k} className="flex items-center gap-2">
              <div className={`w-2.5 h-2.5 rounded-full ${meta.color}`} />
              <span className="font-semibold">{meta.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LagoonMonthly;
